import {
    MODIFICA_TOKEN,
    MODIFICA_NOME
} from '../actions/types';

const INITIAL_STATE = {
    token: '',
    nome: '',
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MODIFICA_NOME:
            return {...state, nome: action.payload}
        case MODIFICA_TOKEN: 
        console.log('ENTROU MODIFICA_TOKEN');
            return {...state, token: action.payload}
        default: 
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/LoginReducer.js